export default {
    elapsedTime: null,
    isTimerActive: null,
    elapsedTimeOnlySeconds:0,
    selectedTakeaway: {},
    isPaused: null,
}